import { CriteriaThresholdEnum } from './application-score.type';

export type ApplicationScoreBadgeTone = 'positive' | 'warning' | 'critical';

export function hasApplicationScore(score?: number | null): score is number {
  return typeof score === 'number' && !Number.isNaN(score);
}

export function compareApplicationScores(
  firstScore?: number | null,
  secondScore?: number | null,
): number {
  const firstHasScore = hasApplicationScore(firstScore);
  const secondHasScore = hasApplicationScore(secondScore);

  if (firstHasScore && secondHasScore) {
    return secondScore - firstScore;
  }

  if (firstHasScore) {
    return -1;
  }

  if (secondHasScore) {
    return 1;
  }

  return 0;
}

export function getApplicationScoreBadgeTone(score: number): ApplicationScoreBadgeTone {
  if (score >= CriteriaThresholdEnum.GREEN) {
    return 'positive';
  }

  if (score >= CriteriaThresholdEnum.YELLOW) {
    return 'warning';
  }

  return 'critical';
}

export function isApplicationNotSourcedByAiRecruiter(
  initiatedByOutreach?: boolean,
  initiatedByCopilot?: boolean,
): boolean {
  return !!initiatedByOutreach && !initiatedByCopilot;
}
